export function linkIframe(iframe: HTMLIFrameElement, html: string) {
  // Reset sandbox — allow-scripts for user HTML execution,
  // but NO allow-same-origin (prevents access to parent DOM/cookies)
  iframe.sandbox.value = '';
  iframe.sandbox.add('allow-scripts');

  // Use srcdoc instead of loading from external domain.
  // The iframe is sandboxed without allow-same-origin,
  // so scripts inside cannot access the parent page.
  iframe.srcdoc = html;
}
